module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "spinner is-loading"
  }), _vm._v(" "), _c('div', {
    staticClass: "overview",
    class: {
      loading: _vm.loading
    }
  }, [_c('Authorised'), _vm._v(" "), _c('Search'), _vm._v(" "), _c('div', {
    staticClass: "stores"
  }, [_c('Type'), _vm._v(" "), _c('GoogleMap', {
    attrs: {
      "lang": _vm.lang
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('Popup'), _vm._v(" "), _c('div'), _vm._v(" "), _c('List')], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5523f9eb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Overview/Index.vue
// module id = 414
// module chunks = 1